import { OrderManagementPermissions } from "@redotech/account-common/permissions";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { FulfillmentService } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { createContext, memo, ReactNode } from "react";
import { RedoOutboundLabelsRpcClientContext } from "../outbound-labels-rpc-client";

export const AssignedFulfillmentServicesContext = createContext<
  FulfillmentService[]
>([]);
export const AssignedFulfillmentServicesService = memo(
  function AssignedFulfillmentServicesService({
    children,
  }: {
    children: ReactNode | ReactNode[];
  }) {
    const client = useRequiredContext(RedoOutboundLabelsRpcClientContext);

    const canSeeFulfillmentServices = useHasPermission(
      OrderManagementPermissions.SCAN_AND_VERIFY,
    );

    const loadState = useLoad(
      async (signal) => {
        if (!canSeeFulfillmentServices) {
          return [];
        }
        const result = await client.getFulfillmentServiceForTeam(
          {},
          { signal },
        );
        return result.fulfillmentServices;
      },
      [client, canSeeFulfillmentServices],
    );

    return (
      <AssignedFulfillmentServicesContext.Provider
        value={loadState.value ?? []}
      >
        {children}
      </AssignedFulfillmentServicesContext.Provider>
    );
  },
);
